import {
  huntLength,
  introLength,
  placementLength,
  testimonialLength,
  tradeLength
} from './timeline.variables';

const timeline = [
  {
    selector: '.NftTestimonial.first',
    transforms: {
      scrollY: {
        translateY: [
          [
            0,
            `3*screenHeight+${introLength + placementLength + huntLength + tradeLength}-1`,
            `3*screenHeight+${introLength + placementLength + huntLength + tradeLength}`,
            `4*screenHeight+${introLength + placementLength + huntLength + tradeLength}`,
            `4*screenHeight+${introLength +
              placementLength +
              huntLength +
              tradeLength +
              testimonialLength}`,
            `4*screenHeight+2*screenWidth+${introLength +
              placementLength +
              huntLength +
              tradeLength +
              3 * testimonialLength}`,
            `5*screenHeight+2*screenWidth+${introLength +
              placementLength +
              huntLength +
              tradeLength +
              3 * testimonialLength}`
          ],
          ['2*screenHeight', '2*screenHeight', 'screenHeight', 0, 0, 0, '-screenHeight']
        ],
        translateX: [
          [
            0,
            `4*screenHeight+${introLength +
              placementLength +
              huntLength +
              tradeLength +
              testimonialLength}`,
            `4*screenHeight+1*screenWidth+${introLength +
              placementLength +
              huntLength +
              tradeLength +
              testimonialLength}`
          ],
          [0, 0, '-screenWidth']
        ]
      }
    }
  }
];

export default timeline;
